(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("sbDataLib", [], factory);
	else if(typeof exports === 'object')
		exports["sbDataLib"] = factory();
	else
		root["sbDataLib"] = factory();
})(window, function() {
return 